(() => {
  if (window.Shopify?.country !== 'DE') return;
  const root = String(window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  const trackingPath = `${root}/apps/track123`;
  const update = link => {
    if (!link) return;
    try {
      const url = new URL(link.getAttribute('href'), window.location.href);
      if (url.origin !== window.location.origin || !/(^|\/)apps\/track123\/?$/.test(url.pathname)) return;
      url.pathname = trackingPath;
      // Carry the destination market through the app proxy, preserving tracking parameters.
      url.searchParams.set('country', 'DE');
      link.href = url.href;
    } catch (_) { /* Leave non-URL links unchanged. */ }
  };
  const updateLinks = () => document.querySelectorAll('a[href*="/apps/track123"]').forEach(update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  else updateLinks();
  // The mobile menu is inserted after load, so handle its links at click time too.
  document.addEventListener('click', event => {
    if (event.target instanceof Element) update(event.target.closest('a[href*="/apps/track123"]'));
  }, true);
})();
